<template>
  <transition name="fade">
    <div
      :class="[
        'mb-6 border-2 p-4 relative flex rounded-xl',
        backgroundColor && theme.middleScreen.backgroundColor,
        // menu.layout == 'frydate' ? 'rounded-none' : 'rounded-xl',
      ]"
      :style="makeStyles(cartProcessItemRadius , kioskItemOverviewBorder, kioskItemOverviewBackground, kioskItemOverviewBorderRadius)"
    >
      <div v-show="!backgroundColor" class="flex-shrink-0 mr-4 flex items-center">
        <div class="w-12 h-auto overflow-hidden flex items-center"
        :style="cartItemImageWidth">
          <Picture
            v-if="cartItem.pictureUrl"
            :src="cartItem.pictureUrl"
            class="rounded-lg rouned-lg object-cover overflow-hidden flex items-center"
            alt
          />
        </div>
      </div>
      <div class="flex-1">
        <div class="flex">
          <div class="text-left md:table-cell h-full pr-1 flex-grow">
            <p :class="['font-bold text-2xl', menu.layout == 'frydate' ? 'text-4xl uppercase' : '']" :style="processTekst">
              <small class="text-primary-light"></small>
              {{ cartItem[`name_${language}`] }}
            </p>
            <div class="flex flex-col">
              <div
                class="flex flex-col"
                v-for="(additionGroup, index) in cartItem.OrderItemAdditions"
                :key="index"
              >
                <!-- Inside Combo Deal there may be multiple Additions inside Addition -->
                <div
                  class="flex flex-col"
                  v-if="Array.isArray(additionGroup.Addition)"
                >
                  <small
                    v-for="nAdditionGroup in additionGroup.Addition"
                    :key="nAdditionGroup.Id"
                    :class="['text-xl text-gray-700']"
                  >
                    {{ nAdditionGroup[`name_${language}`] || "hey" }}
                    <!--extra prices -->
                    <span
                      v-if="nAdditionGroup.price != 0"
                      v-currency="nAdditionGroup.price"
                    />
                  </small>
                </div>
                <small v-else :class="['text-md text-gray-700']">
                  {{ additionGroup["Addition"][`name_${language}`] }}
                  <!-- extra prices -->
                  <span
                    v-if="additionGroup['Addition']['price'] != 0"
                    v-currency="additionGroup['Addition']['price']"
                  />
                </small>
              </div>
            </div>
          </div>
            <div>
            <span
              :class="[
                'text-lg font-bold',
                /* theme.body.textColor */ 'text-new-primary',
                menu.layout == 'frydate' ? 'font-sans' : '',
              ]"
              :style="makeStyles(text , kioskPriceColor)"
              v-currency="totalPriceSum"
            />
          </div>
        </div>
        <div>
          <div :class="['flex rounded-xl items-center mt-4']">
            <!-- :style="btnOutlineActiveBorder + btnOutlineActiveBackground" -->
            <div v-if="cartItem.is_removable">
              <button
                v-if="cartItem.OrderItemAdditions.length !== 0 && false"
                :class="[
                  'fill-current focus:outline-none font-medium rounded-full flex items-center pr-4 mr-6',
                  disableAddButton && 'opacity-50',
                ]"
                :style="addMoreItemsIconBackground"
                :disabled="disableAddButton"
                @click="editCartItem(cartItem, collectedCartItemIds[0])"
              >
                <Icon
                  name="arrow-left"
                  :color="kioskDetailText"
                  class="w-8 h-8 p-2 opacity-50"
                />
                <span :style="btnThirdText">{{
                  lang["edit_order"][language]
                }}</span>
              </button>
            </div>
            <button
              v-if="cartItem.is_removable"
              @click="removeItem(cartItem)"
              :class="[
                'fill-current focus:outline-none font-bold rounded-full',
                disableAddButton && 'opacity-50',
              ]"
              :style="addMoreItemsIconBackground"
              :disabled="disableAddButton"
            >
              <Icon
                name="minus"
                :color="kioskPlusAndMinusButtons"
                class="w-8 h-8 p-2"
              />
            </button>
            <div
              :class="[
                'text-lg mx-2 h-8 text-center flex items-center justify-center',
              ]"
              :style="addMoreItemsNumber"
            >
                <span key="amount">{{ amount }} </span> 
            </div>
            <!-- plus button -->
            <button
              v-if="cartItem.is_removable"
              @click="addToCart(cartItem)"
              :class="[
                'font-bold rounded-full cursor-pointer focus:outline-none',
                disableAddButton && 'opacity-50',
              ]"
              :style="addMoreItemsIconBackground"
            >
              <Icon
                name="plus"
                :color="kioskPlusAndMinusButtons"
                class="w-8 h-8 p-2"
              />
            </button>
          </div>
          <Modal
            v-if="editCollapse"
            openOnMount
            spread
            :name="`cartItem_${cartItem.Id}`"
            @closed="editCollapse = false"
          >
            <div class="sticky top-0">
              <div
                class="bg-red-700 text-white text-center px-4 py-3 text-lg tracking-widest uppercase"
              >
                {{ lang["edit_order_top_notify"][language] }}
              </div>
              <div class="FloatingTitle py-5 -mb-5 px-10 rouned-t-xxl">
                <div class="w-full">
                  <div
                    class="font-bold flex-grow text-center flex self-center justify-center text-5xl"
                    style="color: rgb(229, 30, 30)"
                  >
                    The Bavet Spaghetti
                  </div>
                </div>
              </div>
            </div>
            <div
              :class="['text-center text-xs md:text-lg px-10']"
              :style="itemDescription"
            >
              {{ cartItem["description" + "_" + language] }}
            </div>
            <div class="p-4">
              <div
                v-for="(modifier, index) in availableModifiers"
                :key="index"
                class="px-6 allAdditions"
              >
                <KioskAdditions
                  :arrayNumber="index"
                  :modifiers="availableModifiers"
                  :modifier="modifier"
                  :defaultSelectedIds="defaultSelected"
                  :defaultSelected="cartItem.OrderItemAdditions"
                  :key="index"
                  @change="handleModifiersChange"
                />
              </div>
            </div>
            <div class="sticky bottom-0 p-4 OrderButton__backdrop flex">
              <Button
                @click="discardEdit"
                :class="[
                  'w-full rounded-full relative bg-new-primary rounded px-2 text-md mr-4',
                ]"
                :style="makeStyles(mainButtonRadius,paymentBtnBackground , paymentBtnText)"
              >
                {{ lang["cancel"][language] }}
              </Button>
              <Button
                :disabled="disableAddToCartButton"
                @click="saveEdit"
                :class="[
                  'w-full rounded-full relative bg-new-primary rounded px-2 text-md',
                  disableAddToCartButton
                    ? 'opacity-40 cursor-not-allowed'
                    : 'opacity-100',
                ]"
                :style="makeStyles(mainButtonRadius,paymentBtnBackground , paymentBtnText)"
              >
                {{ lang["save_edited_order"][language] }}
              </Button>
            </div>
          </Modal>
        </div>
      </div>
      <button
        v-if="cartItem.is_removable"
        @click.prevent="deleteItem(cartItem, index)"
        class="w-8 h-8 cursor-pointer absolute right-0 top-0 transform translate-x-1/2 -translate-y-1/2"
      >
        <IconCancel
          classes="fill-current inline-block p-2 rounded-full cursor-pointer"
            :fill="cartItemDestructiveButtonColor"
            :stroke="cartItemDestructiveButtonColor"
            :style="deleteIconKioskBackground"
        />
      </button>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
// import _ from "lodash";

import Icon from "./Icon.vue";
import Button from "./Button.vue";
import KioskAdditions from "./KioskAdditions.vue";
import Modal from "./Modal.vue";

import lang from "../lang";
import { GET } from "../utils";
import IconCancel from "./icons/iconCancel.vue";

export default {
  props: {
    backgroundColor: String,
    amount: Number,
    cartItem: Object,
    collectedCartItemIds: Array,
    index: [String, Number],
    blockUpselling: Boolean,
  },
  data() {
    return {
      lang,
      disableAddToCartButton: false,
      additionPrice: [],
      filteredAdditionPrice: null,
      editCollapse: false,
      modifiers: [],
      availableModifiers: undefined,
      updatedOrderItem: { ...this.cartItem },
      // continueOrdering: false,
      disableAddButton: false,
    };
  },
  components: {
    Icon,
    Button,
    KioskAdditions,
    Modal,
    IconCancel
},
  computed: {
    ...mapGetters([
      "menu",
      "language",
      "hasKiosk",
      "menuHash",
      "sessionId",
      "minSelectedAddition",
      "minSelectedAdditionTotal",
    ]),
    ...mapGetters("Cart", ["cartItems", "paymentTypeId", "orderId"]),
    ...mapGetters("Theme", [
      "deleteIconKioskBackground",
      "cartProcessItemRadius",
      "paymentFloatBackground",
      "kioskDetailText",
      "kioskPlusAndMinusButtons",
      "text",
      "borderMain",
      "processTekst",
      "buttonImgColors",
      "btnDestructiveIcon",
      "kioskItemOverviewBorder",
      "kioskItemOverviewBorderRadius",
      "kioskItemOverviewBackground",
      "kioskPriceColor",
      "addMoreItemsIconBackground",
      "addMoreItemsNumber",
      "customThemeVariables",
      "btnThirdText",
      "paymentBtnBackground",
      "mainButtonRadius",
      "paymentBtnText",
      "itemDescription",
      "cartItemImageWidth",
      "cartItemDestructiveButtonColor"
    ]),
    defaultSelected() {
      // generate array of current selected modifier Id's
      return this.cartItem.OrderItemAdditions.map(({ Addition }) => {
        return Addition && Addition.Id;
      });
    },
    totalPriceSum(){
    return this.cartItem.OrderItemAdditions.reduce((acc,curr)=>{
        if(Array.isArray(curr.Addition)){
          /** Addition may have multiple Additions in comboDeals */
          return (acc += curr.Addition.reduce(
            (ac2, cur2) => (ac2 += cur2.price),
            0
          ));
        }
        return (acc += curr.Addition.price);
      }, this.cartItem.price) * this.amount;
    },
  },
  methods: {
    // removes an item and update the order
    removeItem(item) {
      // Ignore clicks when button is disabled during callback to back-end
      if (this.disableAddButton) return;

      this.$store.commit("Cart/updateShowUpselling", false);
      if (this.disableAddButton != true) {
        this.disableAddButton = true;
        this.additionPrice = [];
        this.filteredAdditionPrice = null;

        this.$store
          .dispatch("Cart/UPDATE_ORDER", {
            operation: "remove",
            item: item,
            activateUpselling: false,
          })
          .then(() => {
            this.itemBeingAdded = "";
            setTimeout(() => (this.disableAddButton = false), 150);
          });
        this.correctItemPrice();
        this.$store.commit("updateIsSwipeOpen", false);
      }
    },
    deleteItem(item) {
      if (this.disableAddButton) return;
      this.$store.commit("Cart/updateShowUpselling", false);
      if (this.disableAddButton != true) {
        this.disableAddButton = true;
        this.additionPrice = [];
        this.filteredAdditionPrice = null;

        this.$store
          .dispatch("Cart/UPDATE_ORDER", {
            operation: "delete",
            item: item,
            activateUpselling: false,
          })
          .then(() => {
            this.itemBeingAdded = "";
            setTimeout(() => (this.disableAddButton = false), 150);
          });
        this.correctItemPrice();
        this.$store.commit("updateIsSwipeOpen", false);
      }
    },
    // add an item to the cart and update the order
    addToCart(item) {
      // Ignore clicks when button is disabled during callback to back-end
      if (this.disableAddButton) return;

      this.disableAddButton = true;
      if (this.blockUpselling)
        this.$store.commit("Cart/updateShowUpselling", false);

      this.$store.commit("Cart/updateOrderItemCount", 1);

      this.currentItem = item;
      this.$store.commit("updateCategoryId", item.MenuCategoryId);

      this.itemBeingAdded = this.currentItem.Id;
      this.$store
        .dispatch("Cart/GET_MENU_ITEM_ORDERING", this.currentItem.Id)
        .then(() => {
          this.itemBeingAdded = "";

          // this.$store.commit("Cart/addItem", this.currentItem);
          this.$store
            .dispatch("Cart/UPDATE_ORDER", {
              operation: "add",
              item: this.currentItem,
              activateUpselling: false,
            })
            .then(() => {
              setTimeout(() => (this.disableAddButton = false), 150);
            });
        })
        .catch(() => {
          this.itemBeingAdded = "";
          this.disableAddButton = false;
        });
    },
    // calculates the correct price inside the cart
    correctItemPrice() {
      // if (this.cartItems) {
      //   let additionItemPrice = 0;
      //   let object = {};
      //   this.cartItems.map((x) => {
      //     additionItemPrice = 0;
      //     if (x.OrderItemAdditions) {
      //       if (x.OrderItemAdditions.length == 0) {
      //         object = {
      //           id: x.Id,
      //           price: 0,
      //         };
      //         this.additionPrice.push(object);
      //       }
      //       x.OrderItemAdditions.map((y) => {
      //         additionItemPrice += y.Addition.price;
      //         object = {
      //           id: x.Id,
      //           price: additionItemPrice,
      //         };
      //       });
      //       this.additionPrice.push(object);
      //       this.filteredAdditionPrice = _.uniqWith(
      //         this.additionPrice,
      //         _.isEqual
      //       );
      //     } else {
      //       object = {
      //         id: x.Id,
      //         price: 0,
      //       };
      //       this.additionPrice.push(object);
      //     }
      //   });
      // }
    },
    async editCartItem(item) {
      const { Id: menuItemId, MenuCategoryId: categoryId } = item;

      this.editCollapse = !this.editCollapse;
      if(this.hasKiosk){
        const { data } = await GET.MENU_ITEM({
          menuHash: this.menuHash,
          categoryId,
          menuItemId,
        });
      this.availableModifiers = await data.Modifiers;
      }else{
        const { data } = await GET.MENU_ITEM({
          menuHash: this.menuHash,
          categoryId,
          menuItemId,
        });
      this.availableModifiers = await data.Modifiers;
      }

    },
    discardEdit() {
      this.editCollapse = false;
    },
    async saveEdit() {
      this.editCollapse = false;
      // this.$store.commit('Cart/updateItemByCartId', this.updatedOrderItem)
      this.removeItem(this.cartItem);
      this.addToCart(this.updatedOrderItem);

      /**
       * @TODO Patch order
       */
    },
    handleModifiersChange({ additionGroup: { AdditionGroupId }, additions }) {
      this.updatedOrderItem.OrderItemAdditions =
        this.updatedOrderItem.OrderItemAdditions.filter(({ Addition }) => {
          return Addition.AdditionGroupId !== AdditionGroupId;
        });

      // merge new modifiers
      if (Array.isArray(additions)) {
        this.updatedOrderItem.OrderItemAdditions =
          this.updatedOrderItem.OrderItemAdditions.concat(additions);
      } else this.updatedOrderItem.OrderItemAdditions.push(additions);

      /**
       * @TODO Sort additions by id
       */
    },
  },
  created() {
    this.correctItemPrice();
    window.$eventBus.$on("add-to-cart-button-disable", (data) => {
      this.disableAddToCartButton = data;
    });
  },
  updated() {
    // if (
    //   this.minSelectedAddition > 0 &&
    //   this.editCollapse &&
    //   !this.continueOrdering
    // ) {
    //   this.$store.commit(
    //     "updateMinSelectedAdditionTotal",
    //     this.minSelectedAddition
    //   );
    //   this.continueOrdering = true;
    // }
  },
  watch: {
    cartItems() {
      this.additionPrice = [];
      this.filteredAdditionPrice = null;
      this.correctItemPrice();
    },
  },
};
</script>

<style></style>
